import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { money } from "@/lib/api";
import { Panel } from "@/components/common";

export function CurrencyRisk({ risk, rc }) {
  if (!risk) return null;
  const { flags, prev_month: prev, month, threshold, by_currency: by = {} } = risk;
  const custom = Object.entries(by).map(([c, v]) => `${c} ${v}%`).join(", ");
  return (
    <Panel title={`Currency risk — forecast moved beyond threshold (default ${threshold}%${custom ? `; ${custom}` : ""})`} testid="currency-risk-panel">
      {!prev ? (
        <p className="text-sm text-slate-500" data-testid="currency-risk-need-history">Needs exchange rates for at least two months. Once Finance enters next month's rates, projects whose {rc} forecast moves more than {threshold}% are flagged here.</p>
      ) : flags.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="currency-risk-none">No project's {rc} forecast moved beyond its threshold between {prev} and {month} rates.</p>
      ) : (
        <div className="space-y-2">
          <p className="text-xs text-slate-500">Forecast (EAC) in {rc} at {prev} rates vs {month} rates. The project's own-currency forecast is unchanged; the move is exchange-rate exposure.</p>
          {flags.map((f) => (
            <div key={f.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-amber-200 bg-amber-50/60 px-3 py-2 text-sm" data-testid={`currency-risk-${f.code}`}>
              <div className="flex items-center gap-2"><AlertTriangle className="h-4 w-4 text-amber-600" />
                <Link to={`/projects/${f.id}`} className="font-medium text-indigo-700 hover:underline">{f.code} {f.name}</Link>
                <span className="font-mono text-xs text-slate-500">{f.currency} · {money(f.eac_native, f.currency)}</span></div>
              <div className="font-mono text-xs">{money(f.before, rc)} → {money(f.after, rc)} <b className={f.pct > 0 ? "text-red-600" : "text-emerald-700"} data-testid={`currency-risk-pct-${f.code}`}>{f.pct > 0 ? "+" : ""}{f.pct}%</b> <span className="text-slate-500">(limit {f.threshold}%)</span></div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
